import { globalPageConfig, storage } from 'lib';

type IDeviceInfo = {
  label: string;
  deviceId: string;
  active?: boolean;
};
// 和rtc sdk 获取的deviceId 不一致，这里弃用
// const getDeviceList = () => {
//   return new Promise((resolve, reject) => {
//     // {
//     // "camera": "1dab1afab4ea70a57e3e82f48553e1b745bd1fc66a5a2e34765be4ced45e5642",
//     // "cameraName": "FaceTime高清摄像头 (B6DF:451A)",
//     // "mic": "default",
//     // "plugin": 1,
//     // "title": "滴答直播主题"
//     // }
//     const deviceInfo = storage.getItem('CLIENT_LIVE_DEVICE_INFO') || {};
//
//     navigator.mediaDevices
//       .enumerateDevices()
//       .then((devices) => {
//         console.log('devices', devices);
//
//         const cameras: IDeviceInfo[] = [];
//         const microphones: IDeviceInfo[] = [];
//         devices.forEach((device) => {
//           if (device.kind === 'audioinput' && device.deviceId) {
//             microphones.push({
//               deviceId: device.deviceId,
//               label: device.label || `麦克风${microphones.length}${1}`,
//             });
//           }
//           if (device.kind === 'videoinput' && device.deviceId) {
//             cameras.push({
//               deviceId: device.deviceId,
//               label: device.label || `摄像头${microphones.length}${1}`,
//             });
//           }
//         });
//
//         if (cameras.length > 0) {
//           const activeCamera = cameras.find((item) => {
//             return item.deviceId === deviceInfo.camera;
//           });
//           if (activeCamera) {
//             activeCamera.active = true;
//           } else {
//             cameras[0].active = true;
//           }
//         }
//         if (microphones.length > 0) {
//           const activeMic = microphones.find((item) => {
//             return item.deviceId === deviceInfo.mic;
//           });
//           if (activeMic) {
//             activeMic.active = true;
//           } else {
//             microphones[0].active = true;
//           }
//         }
//
//         console.log('getDeviceList', {
//           cameras,
//           microphones,
//         });
//
//         resolve({
//           cameras,
//           microphones,
//         });
//       })
//       .catch((err) => {
//         reject(err?.message || '获取设备异常');
//       });
//   });
// };

const getStreamConfig = (streamType, videoInputName) => {
  return globalPageConfig.getClientStreamConfig({
    streamType,
    deviceName: videoInputName,
  });
};

export default {
  getStreamConfig,
};
